// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#vendor-form .description-height{height:200px !important}.header-searches{display:flex}.header-searches .header-search-input[name=shop]{margin-right:40px}.validation-message{color:#ff5f4b;height:.7rem;font-size:.9rem;margin:0}", ""]);
// Exports
module.exports = exports;
